<template>
  <div class="live">
    <div class="liveBar">
      <div class="liveBarCon">
        <div class="liveBarFilter"></div>
        <div class="liveBarInfoCon">
          <div class="liveImg">
            <img :src="onAirInfoData.programUrl" alt="" />
          </div>
          <div class="liveInfo">
            <div class="liveTitle" @click="toColumHome">
              <h1>{{ onAirInfoData.title }}</h1>
            </div>
            <div class="liveDate">
              <span>{{onAirInfoData.day}}</span>
              <span>{{onAirInfoData.startTime}}-{{onAirInfoData.stopTime}}</span>
            </div>
            <div class="liveBtns">
              <div class="js-liveBtns-play" :data-url="onAirInfoData.defultMediaUrl" data-id="" data-type="live" :data-title="onAirInfoData.title" :data-date="onAirInfoData.day" :data-time="onAirInfoData.startTime+'-'+onAirInfoData.stopTime" :data-img="onAirInfoData.programUrl" :data-announcer="onAirInfoData.hostsName" :data-info="onAirInfoData.info" :data-program-title="onAirInfoData.programTitle" @click="LiveBtnplay($event,true)">
                <span>On Air Now</span>
                <i></i>
              </div>
              <div class="js-liveBtns-toShows">
                <router-link :to="showsUrl">
                  <i></i>
                  <span>View Schedules</span>
                </router-link>
              </div>
            </div>
            <div class="liveSummary">
              <span>{{ onAirInfoData.info }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="maxWidth mod pad">
      <h2 class="mod-title">
        <strong>Listen Live</strong>
      </h2>
      <div class="radioStationCon" v-if="screenWidth > 900">
        <div class="swiper-container radioSlide">
          <div class="swiper-wrapper">
            <div class="swiper-slide" :class="{'active':onAirInfoData.radioItemActive==0}">
              <div class="radioPic">
                <img src="../../static/img/file/radio-ez-img.png" alt="">
                <div class="current" data-url="http://sk.cri.cn/915.m3u8" data-id="" data-type="live" data-title="" data-date="" data-time="" data-img="" data-announcer="" data-info="" data-program-title="" data-showsurl="/shows" @click="play($event,true,0)">
                  <i></i>
                </div>
              </div>
              <div class="radioInfo swiper-no-swiping">
                <span class="radioInfoName">EZFM</span>
                <span class="radioInfoShowName"></span>
              </div>
            </div>
            <div class="swiper-slide" v-for="(item,key) in radioListData" :key="key" :class="{'active':onAirInfoData.radioItemActive==key+1}">
              <div class="radioPic">
                <img :src="item.programUrl" alt="" />
                <div
                  class="current"
                  :data-url="item.mediaUrl"
                  :data-id="item.id"
                  data-type="live"
                  :data-title="item.programTitle"
                  :data-date="item.day"
                  :data-time="item.startTime + '-' + item.stopTime"
                  :data-img="item.programUrlTwo"
                  data-announcer=""
                  :data-info="item.info"
                  :data-program-title="item.title"
                  :data-showsurl="'/shows/'+item.id"
                  @click="play($event, true, key + 1)"
                >
                  <i></i>
                </div>
              </div>
              <div class="radioInfo swiper-no-swiping">
                <span class="radioInfoName">{{ item.title }}</span>
                <span class="radioInfoShowName">{{ item.programTitle }}</span>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
      <div class="radioStationCon" v-else>
        <div class="swiper-container radioSlide">
          <div class="swiper-wrapper">
            <div class="swiper-slide" data-url="http://sk.cri.cn/915.m3u8" data-id="" data-type="live" data-title="" data-date="" data-time="" data-img="" data-announcer="" data-info="" data-program-title="" data-showsurl="/shows" @click="play($event,true,0)" :class="{'active':onAirInfoData.radioItemActive==0}">
              <div class="radioPic">
                <img src="../../static/img/file/radio-ez-img.png" alt="" />
                <div class="current">
                  <i></i>
                </div>
              </div>
              <div class="radioInfo swiper-no-swiping">
                <span class="radioInfoName">EZFM</span>
                <span class="radioInfoShowName"></span>
              </div>
            </div>
            <div class="swiper-slide" v-for="(item,key) in radioListData" :key="key" :data-url="item.mediaUrl" :data-id="item.id" data-type="live" :data-title="item.programTitle" :data-date="item.day" :data-time="item.startTime+'-'+item.stopTime" :data-img="item.programUrlTwo" data-announcer="" :data-info="item.info" :data-program-title="item.title" :data-showsurl="'/shows/'+item.id" @click="play($event,true,key+1)" :class="{'active':onAirInfoData.radioItemActive==key+1}">
              <div class="radioPic">
                <img :src="item.programUrl" alt="" />
                <div class="current">
                  <i></i>
                </div>
              </div>
              <div class="radioInfo swiper-no-swiping">
                <span class="radioInfoName">{{ item.title }}</span>
                <span class="radioInfoShowName">{{ item.programTitle }}</span>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </div>

    <div class="maxWidth mod pad" v-for="(item, key) in lanesList" :key="key">
      <h2 class="mod-title">
        <router-link :to="'/laneList/'+'add/' + item.id" class="more" v-if="item.hasDetail == 1"
          >更多></router-link
        >
        <strong>{{ item.title }}</strong>
      </h2>
      <div class="photoThreeCon">
        <dl v-for="(item1, key) in item.data" :key="key">
          <router-link :to="typeObj[item1.type+'']+'/'+item1.type+'/'+item1.id">
            <dt>
              <img :src="item1.picurl" alt="" />
            </dt>
            <dd>
              <h4>{{ item1.title }}</h4>
            </dd>
          </router-link>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Live",
  data() {
    return {
      msg: "live",
      screenWidth:document.documentElement.clientWidth,
      isLivePlay:false,
      onAirInfoData:{
        defultMediaUrl:'http://sk.cri.cn/915.m3u8',
        radioItemActive:0,
      },
      radioListData:[],
      lanesList:[],
      typeObj:{
        ezfm:"/columnList",
        other:"/columnList",
        recommend:"/detail",
        ezfmHistory:"/detail",
        otherHistory:"/detail",
        more:"/detail",
        lane:"/laneList"
      },
      showsUrl:'/shows',
    };
  },
  methods: {
    radioSlide: function () {
      var _this = this;
      if (this.screenWidth <= 900) {
        _this.$nextTick(function () {
          new Swiper(".radioSlide", {
            loop: false, // 循环模式选项
            slidesPerView: 4,
            slidesPerGroup: 4,
          });
        });
      } else {
        _this.$nextTick(function () {
          new Swiper(".radioSlide", {
            loop: false, // 循环模式选项
            slidesPerView: 5,
            slidesPerGroup: 5,
            prevButton: ".swiper-button-prev", //不要忘记点
            nextButton: ".swiper-button-next",
          });
        });
      }
    },
    play:function(event,type,key){
      var _this = this , _el = $(event.currentTarget) , _curPage = $(_this.$parent.$children[3].$el) , _type = type , _index = key;
      if(_curPage.attr('class') != 'player'){
        _this.$parent.$children[2].audioPlay(_el, _type);
      } else {
        _this.$parent.$children[3].audioPlay(_el, _type);
      }
      _this.onAirInfoData.radioItemActive = _index;
      _this.onAirInfoData.programUrl = _el.attr('data-img');
      _this.onAirInfoData.title = _el.attr('data-title');
      _this.onAirInfoData.day = _el.attr('data-date');
      _this.onAirInfoData.startTime = _el.attr('data-time').substring(0,5);
      _this.onAirInfoData.stopTime = _el.attr('data-time').substring(6,11);
      _this.onAirInfoData.hostsName = _el.attr('data-announcer');
      _this.onAirInfoData.info = _el.attr('data-info');
      _this.onAirInfoData.programTitle = _el.attr('data-program-title');
      _this.onAirInfoData.defultMediaUrl = _el.attr('data-url');
      _this.showsUrl = _el.attr('data-showsurl');
      // 将当前直播的信息储存到sessionStorge中
      // sessionStorage.setItem('onAirInfo',JSON.stringify(_this.onAirInfoData)); // 转为string存储
      
      
      if(!!window.ActiveXObject || "ActiveXObject" in window){//ie11及以下不包括edge
        $('.liveBarFilter').css('background','url("../../static/img/liveBgImg-ie.png") no-repeat');
      }else{
        $('.liveBarFilter').css('background','url("'+_this.onAirInfoData.programUrl+'") no-repeat');
  　　}
      $('.liveBarFilter').css('backgroundSize','100% 100%');
    },
    LiveBtnplay:function(event,type){
      var _this = this , _el = $(event.currentTarget) , _curPage = $(_this.$parent.$children[3].$el) , _type = type;
      if(_curPage.attr('class') != 'player'){
        _this.$parent.$children[2].audioPlay(_el, _type);
      }else{
        _this.$parent.$children[3].audioPlay(_el, _type);
      }
    },
    getLiveData:function(){
      var _this = this;
      _this.$http.post('/qertyuiy/v3/live?session=8295f0a6-6804-4d61-8944-4f8d60a71cd4')
      .then(async function(res){    
        var onAirInfo = res.data.onair , radioList = res.data.data , hostsData = res.data.onair.hosts;
        // 过滤接口中返回的当前直播信息
        var startTime = onAirInfo.startTime.substring(0,5) , stopTime = onAirInfo.stopTime.substring(0,5);
        var pcFirstRadio = $('.swiper-slide').eq(0).children('.radioPic').children('.current') , mobilFirstRadio = $('.swiper-slide').eq(0);
        onAirInfo.startTime = startTime;
        onAirInfo.stopTime = stopTime;
        onAirInfo.hostsName = '';
        onAirInfo.defultMediaUrl = 'http://sk.cri.cn/915.m3u8';
        onAirInfo.radioItemActive = 0;
        for(var i=0;i<hostsData.length;i++){
          onAirInfo.hostsName += hostsData[i].hostName+' ';
        }
        // 判断sessionstorage中是否有当前直播信息
        // if(sessionStorage.getItem('onAirInfo') != null){
        //   _this.onAirInfoData = $.parseJSON(sessionStorage.getItem('onAirInfo'));
        // }else{
          
        // }
        // 将过滤后的当前直播信息放在变量中
        _this.onAirInfoData.radioItemActive = onAirInfo.radioItemActive;
        _this.onAirInfoData.programUrl = onAirInfo.programUrl;
        _this.onAirInfoData.title = onAirInfo.title;
        _this.onAirInfoData.day = onAirInfo.day;
        _this.onAirInfoData.startTime = onAirInfo.startTime;
        _this.onAirInfoData.stopTime = onAirInfo.stopTime;
        _this.onAirInfoData.hostsName = onAirInfo.hostsName;
        _this.onAirInfoData.info = onAirInfo.info;
        _this.onAirInfoData.programTitle = onAirInfo.programTitle;
        // 给默认EZ频率的slide单独设置直播信息
        if($('.swiper-slide').length > 0){
          if(_this.screenWidth > 900){
            pcFirstRadio.attr('data-title',onAirInfo.title);
            pcFirstRadio.attr('data-date',onAirInfo.day);
            pcFirstRadio.attr('data-time',onAirInfo.startTime+'-'+onAirInfo.stopTime);
            pcFirstRadio.attr('data-img',onAirInfo.programUrl);
            pcFirstRadio.attr('data-announcer',onAirInfo.hostsName);
            pcFirstRadio.attr('data-info',onAirInfo.info);
            pcFirstRadio.attr('data-program-title',onAirInfo.programTitle);
          }else{
            mobilFirstRadio.attr('data-title',onAirInfo.title);
            mobilFirstRadio.attr('data-date',onAirInfo.day);
            mobilFirstRadio.attr('data-time',onAirInfo.startTime+'-'+onAirInfo.stopTime);
            mobilFirstRadio.attr('data-img',onAirInfo.programUrl);
            mobilFirstRadio.attr('data-announcer',onAirInfo.hostsName);
            mobilFirstRadio.attr('data-info',onAirInfo.info);
            mobilFirstRadio.attr('data-program-title',onAirInfo.programTitle);
          }
          $('.swiper-slide').eq(0).children('.radioInfo').children('.radioInfoShowName').text(onAirInfo.programTitle);
        }
        if(!!window.ActiveXObject || "ActiveXObject" in window){//ie11及以下不包括edge
          $('.liveBarFilter').css('background','url("../../static/img/liveBgImg-ie.png") no-repeat');
        }else{
          $('.liveBarFilter').css('background','url("'+ _this.onAirInfoData.programUrl+'") no-repeat');
    　　}
        
        $('.liveBarFilter').css('backgroundSize','100% 100%');
        // 请求其他的直播频率信息
        for(var j=0;j<radioList.length;j++){
          var _index = j;
          await _this.$http.post('/qertyuiy/v3/live/detail?id='+radioList[j].id+'&session=8295f0a6-6804-4d61-8944-4f8d60a71cd4')
          .then(function(res){        
            var data = res.data.data;
            radioList[_index].programTitle = data.programTitle;
            radioList[_index].day = data.day;
            radioList[_index].programUrlTwo = data.programUrl;
            radioList[_index].info = data.info;
            if('startTime' in data && 'stopTime' in data){
              radioList[_index].startTime = data.startTime;
              radioList[_index].stopTime = data.stopTime;
            }else{
              radioList[_index].startTime = '00:00';
              radioList[_index].stopTime = '23:59';
            }
          })
          .catch(function(e){

          })
        }
        _this.radioListData = radioList;
        _this.radioSlide();
      })
      .catch(function(e){

      })
    },
    getLaneList: function () {
      var _this = this;
      _this.$http.post('/qertyuiy/v3/classification/detail?id=11&session=8295f0a6-6804-4d61-8944-4f8d60a71cd4')
      .then(function(res){        
        var data = res.data.data;
        _this.lanesList = data.lanes;
        for(var i=0;i<_this.lanesList.length;i++){
          if(_this.lanesList[i].hasDetail == 1){
            _this.lanesList[i].data = _this.lanesList[i].data.slice(0,6);
          }
        }
      })
      .catch(function(e){

      })
    },
    isAddJsPlay:function(){
      var _this = this , _curPage = $(_this.$parent.$children[3].$el) , _player;
      sessionStorage.setItem('isFirstLoad','true');
      _this.$nextTick(function(){
        if(_curPage.attr('class') != 'player'){
          _player = _this.$parent.$children[2].globalPlayer;
        }else{
          _player = _this.$parent.$children[3].globalPlayer;
        }
        if(_player.cache_.source.type == 'application/x-mpegURL'){
          if(sessionStorage.getItem('isFirstLoad') != null){
            $('.js-liveBtns-play').removeClass('js-play');
          }else{
            $('.js-liveBtns-play').addClass('js-play');
          }
        }else{
          $('.js-liveBtns-play').removeClass('js-play');
        }
      })
    },
    toColumHome:function(){
      var _this = this , _curPage = $(_this.$parent.$children[3].$el) , _player;
      if(_curPage.attr('class') != 'player'){
        _player = _this.$parent.$children[2].globalPlayer;
      }else{
        _player = _this.$parent.$children[3].globalPlayer;
      }
      if(_player.cache_.source.src == 'http://sk.cri.cn/915.m3u8' || _player.cache_.source.src == '//sk.cri.cn/915.m3u8' || _player.cache_.source.type != 'application/x-mpegURL'){
        _this.$router.push("/columnHome");
      }else{
        return false;
      }
      
    },
  },
  mounted: function () {
    this.getLiveData();
    this.getLaneList();
    this.isAddJsPlay();
  }
};
</script>


<style scoped lang="scss">
.live {
  

  /**/
  .liveBarCon {
    height: 456px;
    width: 100%;
    overflow: hidden;
    position: relative;
    background-color: #000;
  }
  .liveBarInfoCon {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    height: 100%;
    overflow: hidden;
    clear: both;
    width: 1165px;
    margin: auto;
  }
  .liveBarFilter {
    height: 456px;
    width: 100%;
    background: url("") no-repeat;
    background-size: 100% 100%;
    -webkit-filter: blur(50px);
    -moz-filter: blur(50px);
    -o-filter: blur(50px);
    -ms-filter: blur(50px);
    filter: blur(50px);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
  @supports (-webkit-backdrop-filter: brightness(0%) blur(50px)) or
    (backdrop-filter: brightness(0%) blur(50px)) {
    /* 支持 backdrop-filter 时应用的效果，记得把一些属性覆盖掉 */
    .liveBarFilter {
      // background-color: rgba(255, 255, 255, 0.3);
      -webkit-backdrop-filter: brightness(0%) blur(50px);
      backdrop-filter: brightness(0%) blur(50px);
    }
  }
  .liveImg {
    float: left;
    width: 510px;
    height: 340px;
    overflow: hidden;
    margin-top: 58px;
  }
  .liveImg img {
    width: 100%;
  }
  .liveInfo {
    float: left;
    width: 600px;
    margin-top: 80px;
    margin-left: 55px;
  }
  .liveTitle {
    width: 100%;
  }
  .liveTitle h1 {
    color: #fff;
    font-size: 36px;
    cursor: pointer;
  }
  .liveDate {
    overflow: hidden;
    clear: both;
    margin-top: 5px;
  }
  .liveDate span {
    color: #fff;
    float: left;
    font-size: 20px;
    margin-right: 40px;
  }
  .liveBtns {
    overflow: hidden;
    clear: both;
    margin-top: 15px;
  }
  .js-liveBtns-play {
    float: left;
    overflow: hidden;
    cursor: pointer;
    border-radius: 40px;
    border: 2px solid #ffffff;
    padding: 10px 15px;
  }
  .js-liveBtns-play span {
    color: #fff;
    font-size: 22px;
    float: left;
    font-weight: 100;
    line-height: 24px;
  }
  .js-liveBtns-play i {
    float: left;
    width: 24px;
    height: 24px;
    background: url("../../static/img/playPause.png") no-repeat;
    background-size: 24px 48px;
    margin-left: 15px;
    background-position-y: 1px;
  }
  .js-liveBtns-play.play i {
    background-position-y: -24px;
  }
  .js-liveBtns-toShows {
    float: left;
    overflow: hidden;
    margin-top: 32px;
    margin-left: 20px;
  }
  .js-liveBtns-toShows i {
    float: left;
    width: 14px;
    height: 14px;
    background: url("../../static/img/icon-toShows.png") no-repeat center center;
    background-size: 14px 13px;
  }
  .js-liveBtns-toShows span {
    float: left;
    color: #fff;
    font-size: 16px;
    line-height: 16px;
    margin-left: 7px;
  }
  .liveSummary {
    width: 430px;
    margin-top: 15px;
    line-height: 25px;
    max-height: 125px;
    overflow: hidden;
  }
  .liveSummary span {
    color: #fff;
    font-size: 16px;
  }

  /**/
  .radioStationCon {
    margin-top: 30px;
    position: relative;
    .radioSlide {
      position: unset;
      width: 1100px;
    }
    .radioPic {
      width: 180px;
      height: 180px;
      position: relative;
      cursor: pointer;
      margin: 0 auto;
    }
    .radioPic img {
      width: 100%;
      border-radius: 50%;
    }
    .radioPic .current {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.4);
      display: none;
    }
    .radioPic .current i {
      width: 43px;
      height: 43px;
      background: url("../../static/img/playPause.png") no-repeat;
      background-size: 43px 86px;
      background-position-y: 0px;
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
    }
    .radioPic:hover .current {
      display: block;
    }
    .radioSlide .swiper-slide.active .radioPic .current {
      display: block;
    }
    .radioInfo {
      width: 180px;
      margin: 0 auto;
      margin-top: 5px;
    }
    .radioInfo span {
      text-align: center;
      display: block;
      font-size: 22px;
      line-height: 34px;
    }
    .radioInfo .radioInfoName {
      font-weight: bold;
    }
    .radioInfo .radioInfoShowName {
      max-height: 68px;
      overflow: hidden;
    }
    .swiper-button-next,
    .swiper-button-prev {
      width: 27px;
      height: 50px;
    }
    .swiper-button-next {
      top: 88px;
      right: 0;
      background: url("../../static/img/right.png") no-repeat;
      background-size: 27px 50px;
    }
    .swiper-button-prev {
      top: 88px;
      left: 0;
      background: url("../../static/img/left.png") no-repeat;
      background-size: 27px 50px;
    }
  }
}
@media screen and (max-width: 900px) {
  .live {

    /**/
    .liveBarCon {
      width: 6.4rem;
      height: 7.74rem;
    }
    .liveBarInfoCon {
      width: 100%;
    }
    .liveBarFilter {
      height: 100%;
    }
    .liveImg {
      width: 100%;
      height: 4.27rem;
      margin-top: .9rem;
      img{display: block;}
    }
    .liveInfo {
      width: 100%;
      margin-top: 0;
      margin-left: 0;
    }
    .liveTitle {
      width: 5.5rem;
      margin: 0 auto;
      margin-top: .12rem;
    }
    .liveTitle h1 {
      font-size: 0.34rem;
    }
    .liveDate {
      width: 5.5rem;
      margin: 0 auto;
    }
    .liveDate span {
      font-size: 0.22rem;
      line-height: 0.44rem;
    }
    .liveBtns {
      position: absolute;
      top: 0;
      width: 5.5rem;
      margin: 0.22rem auto 0;
      left: 0.45rem;
    }
    .js-liveBtns-play {
      padding: 0.1rem 0.15rem;
      border-radius: 0.4rem;
    }
    .js-liveBtns-play span {
      font-size: 0.22rem;
      line-height: 0.26rem;
    }
    .js-liveBtns-play i {
      width: 0.24rem;
      height: 0.24rem;
      background-size: 0.24rem 0.48rem;
      margin-left: 0.15rem;
      background-position-y: 0.01rem;
    }
    .js-liveBtns-play.play i {
      background-position-y: -0.24rem;
    }
    .js-liveBtns-toShows {
      float: right;
      margin-top: 0.18rem;
      margin-left: 0;
    }
    .js-liveBtns-toShows i {
      width: 0.2rem;
      height: 0.2rem;
      background-size: 0.2rem 0.19rem;
    }
    .js-liveBtns-toShows span {
      font-size: 0.22rem;
      line-height: 0.22rem;
      margin-left: 0.07rem;
    }
    .liveSummary {
      width: 4.17rem;
      line-height: 0.25rem;
      max-height: 1.25rem;
      margin-left: 0.45rem;
      margin-top: 0;
    }
    .liveSummary span {
      font-size: 0.16rem;
      display: block;
    }

    /**/
    .radioStationCon {
      margin-top: 0.3rem;
      position: relative;
      .radioSlide {
        width: 100%;
      }
      .radioPic {
        width: 1.2rem;
        height: 1.2rem;
        cursor: pointer;
        margin: 0 auto;
      }
      .radioPic .current i {
        width: 0.3rem;
        height: 0.3rem;
        background: url("../../static/img/playPause.png") no-repeat;
        background-size: 0.3rem 0.6rem;
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
      }
      .radioPic.play .current i {
        background-position-y: 0rem;
      }
      .radioPic.pause .current i {
        background-position-y: -0.3rem;
      }
      .radioPic:hover .current {
        display: none;
      }
      .radioSlide .swiper-slide.active .radioPic .current {
        display: block;
      }
      .radioInfo {
        width: 180px;
        margin: 0 auto;
        margin-top: 5px;
      }
      .radioInfo span {
        text-align: center;
        display: block;
        font-size: 22px;
        line-height: 34px;
      }
      .radioInfo .radioInfoName {
        font-weight: bold;
      }
      .radioInfo .radioInfoShowName {
        max-height: 68px;
        overflow: hidden;
      }
      .swiper-button-next,
      .swiper-button-prev {
        display: none;
      }
      .radioInfo {
        width: 1.2rem;
        margin: 0 auto;
        margin-top: 0.05rem;
      }
      .radioInfo span {
        text-align: center;
        display: block;
        font-size: 0.22rem;
        line-height: 0.34rem;
      }
      .radioInfo .radioInfoName {
        font-weight: bold;
      }
      .radioInfo .radioInfoShowName {
        max-height: 0.68rem;
        overflow: hidden;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Live.vue